// extracted by mini-css-extract-plugin
module.exports = {"icon_container":"IconContainer_icon_container__fWero","slop":"IconContainer_slop__U_jrS","visible_hit_slop":"IconContainer_visible_hit_slop__s3xfd"};